import React from "react";

import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {closeFlowVariantB, RegistrationFlowStepVariantB, setStepVariantB} from "../../auth/state/registration_flow_variantB_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserPhoneVerificationProvider} from "../providers/UserPhoneVerificationProvider";

interface IProps {
    isOpen: boolean;
    onSuccess?: () => void;
}

export const UserPhoneVerification = (props: IProps) => {
    const {isOpen, onSuccess} = props;
    const dispatch = useAppDispatch();

    const handleClose = () => {
        dispatch(closeFlowVariantB());
    };

    const handleChangeNumber = () => {
        dispatch(setStepVariantB({step: RegistrationFlowStepVariantB.PHONE_COMPLETION}));
    };

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase isOpen={isOpen} onClose={handleClose} onSuccess={onSuccess} onChangeNumber={handleChangeNumber} />
        </UserPhoneVerificationProvider>
    );
};
